import React from "react";
import {Form} from "react-bootstrap";

class SortBy extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }


  handleInputChange(event) {
    //general handlerfor updaing the input value into state.
    //grab values from the input
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    this.props.handleInputChange(name, value);
  }



  render() {
    return (
      <Form  className="sort-by">

        {/* <Form.Group>      */}
          <Form.Label>Sort by:</Form.Label>
          <Form.Control as="select" className="popover-select" name="sortBy" id="sortBy" value={this.props.sortBy} onChange={this.handleInputChange}>
            <option defaultValue="Date Ordered">Date Ordered</option>
            <option value="Date Loaded">Date Loaded</option>
          </Form.Control>
        {/* </Form.Group> */}

      </Form>
    );
  }
}

export default SortBy;
